import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableId = 'tableCustomers';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var truncateMessageOptions = {
    length: 100
}

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class IndexPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: IndexPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[100, 200, 300, -1], [100, 200, 300, "All"]],
            columns: [
                {
                    data: 'Name',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkName${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: "Code",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "PlatformName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnPlatform${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "Status",
                    render: (data: any, type: any, rowData: any) => {
                        //var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = `status-${data.toLowerCase()}`;
                        return `<span id='spnState${rowData.Id}' class='${css}'>${data}</span>`;
                    }
                },
                {
                    data: "FreeRoundBonusEnabled",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var statusCss = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnState${rowData.Id}' class='${statusCss}'>${text}</span>`;
                    }
                },
                {
                    data: "Description",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnDescription${rowData.Id}'>${_.truncate(data, truncateMessageOptions)}</span>`)
                },
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/IndexPage.ts
 **/